// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from '@hey-api/client-fetch';
import type { GetApiV1ActivityData, GetApiV1ActivityResponse, GetApiV1ActivityUuidData, GetApiV1ActivityUuidResponse, PostapiV1ActivityAudioResumeData, PostapiV1ActivityDiagramData, PostapiV1ActivityExpandData, PostapiV1ActivityExplainData, PostapiV1ActivityFlashcardData, PostapiV1ActivityQuizData, PostapiV1ActivityQuizMixedData, PostapiV1ActivityQuizElementOrderData, PostapiV1ActivityQuizElementOrderResponse, PostapiV1ActivityQuizFillBlankData, PostapiV1ActivityQuizFillBlankResponse, PostapiV1ActivityQuizGroupingData, PostapiV1ActivityQuizGroupingResponse, PostapiV1ActivityQuizMatchingData, PostapiV1ActivityQuizMatchingResponse, PostapiV1ActivityQuizOpenEndedData, PostapiV1ActivityQuizOpenEndedResponse, PostapiV1ActivityQuizTrueFalseData, PostapiV1ActivityQuizTrueFalseResponse, PostapiV1ActivityShortAnswerData, PostapiV1ActivityShortAnswerResponse, PostapiV1ActivityShortAnswerEvaluateData, PostapiV1ActivityShortAnswerEvaluateResponse, PostapiV1ActivityTextResumeData, PostapiV1ActivityTextResumeResponse, PostapiV1ActivityUnderlineData, PostapiV1ActivityUnderlineResponse, PostapiV1ActivityThreadData, PostapiV1ActivityThreadResponse, PostapiV1ActivityUuidThreadMessageData, PostapiV1ActivityUuidEvaluateData, GetApiV1ContentSyllabusAfoidData, GetApiV1ContentSyllabusAfoidResponse, GetApiV1ContentSyllabusAfoidExtendedData, GetApiV1ContentSyllabusAfoidExtendedResponse, GetApiV1ContentIdIsProcessedData, PostapiV1ActivityObjectiveData, PostapiV1ActivityObjectiveResponse, PostapiV1ActivityDiscoverData, PostapiV1ActivityDiscoverResponse, PostapiV1ActivityPodcastData, PostapiV1ActivityPodcastResponse, PostapiV1ActivityApplicationData, PostapiV1ActivityApplicationResponse, PostapiV1ActivityBibliographyData, PostapiV1ActivityBibliographyResponse, PostapiV1ActivityExplainSimpleData, PostapiV1ActivityExplainSimpleResponse, PostapiV1ActivityRememberData, PostapiV1ActivityRememberResponse, PostapiV1ActivityRegulationData, PostapiV1ActivityRegulationResponse, PostapiV1ActivityGlossaryData, PostapiV1ActivityGlossaryResponse, GetApiV1ContentUserUseridCourseUdiidContentData } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Allows to obtain the activity sorted in descending and paginated order.
 */
export const getApiV1Activity = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1ActivityData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetApiV1ActivityResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/activity',
        ...options
    });
};

/**
 * Get an activity by uuid.
 */
export const getApiV1ActivityUuid = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ActivityUuidData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiV1ActivityUuidResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/activity/{uuid}',
        ...options
    });
};

export const postapiV1ActivityAudioResume = <ThrowOnError extends boolean = false>(options: Options<PostapiV1ActivityAudioResumeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/activity/audio-resume',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postapiV1ActivityDiagram = <ThrowOnError extends boolean = false>(options: Options<PostapiV1ActivityDiagramData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/activity/diagram',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postapiV1ActivityExpand = <ThrowOnError extends boolean = false>(options: Options<PostapiV1ActivityExpandData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/activity/expand',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postapiV1ActivityExplain = <ThrowOnError extends boolean = false>(options: Options<PostapiV1ActivityExplainData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/activity/explain',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postapiV1ActivityFlashcard = <ThrowOnError extends boolean = false>(options: Options<PostapiV1ActivityFlashcardData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/activity/flashcard',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postapiV1ActivityQuiz = <ThrowOnError extends boolean = false>(options: Options<PostapiV1ActivityQuizData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/activity/quiz',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postapiV1ActivityQuizMixed = <ThrowOnError extends boolean = false>(options: Options<PostapiV1ActivityQuizMixedData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/activity/quiz-mixed',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postapiV1ActivityQuizElementOrder = <ThrowOnError extends boolean = false>(options: Options<PostapiV1ActivityQuizElementOrderData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostapiV1ActivityQuizElementOrderResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/activity/quiz-element-order',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postapiV1ActivityQuizFillBlank = <ThrowOnError extends boolean = false>(options: Options<PostapiV1ActivityQuizFillBlankData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostapiV1ActivityQuizFillBlankResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/activity/quiz-fill-blank',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postapiV1ActivityQuizGrouping = <ThrowOnError extends boolean = false>(options: Options<PostapiV1ActivityQuizGroupingData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostapiV1ActivityQuizGroupingResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/activity/quiz-grouping',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postapiV1ActivityQuizMatching = <ThrowOnError extends boolean = false>(options: Options<PostapiV1ActivityQuizMatchingData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostapiV1ActivityQuizMatchingResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/activity/quiz-matching',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postapiV1ActivityQuizOpenEnded = <ThrowOnError extends boolean = false>(options: Options<PostapiV1ActivityQuizOpenEndedData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostapiV1ActivityQuizOpenEndedResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/activity/quiz-open-ended',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postapiV1ActivityQuizTrueFalse = <ThrowOnError extends boolean = false>(options: Options<PostapiV1ActivityQuizTrueFalseData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostapiV1ActivityQuizTrueFalseResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/activity/quiz-true-false',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postapiV1ActivityShortAnswer = <ThrowOnError extends boolean = false>(options: Options<PostapiV1ActivityShortAnswerData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostapiV1ActivityShortAnswerResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/activity/short-answer',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postapiV1ActivityShortAnswerEvaluate = <ThrowOnError extends boolean = false>(options: Options<PostapiV1ActivityShortAnswerEvaluateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostapiV1ActivityShortAnswerEvaluateResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/activity/short-answer/evaluate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postapiV1ActivityTextResume = <ThrowOnError extends boolean = false>(options: Options<PostapiV1ActivityTextResumeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostapiV1ActivityTextResumeResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/activity/text-resume',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postapiV1ActivityUnderline = <ThrowOnError extends boolean = false>(options: Options<PostapiV1ActivityUnderlineData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostapiV1ActivityUnderlineResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/activity/underline',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postapiV1ActivityThread = <ThrowOnError extends boolean = false>(options: Options<PostapiV1ActivityThreadData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostapiV1ActivityThreadResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/activity/thread',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postapiV1ActivityUuidThreadMessage = <ThrowOnError extends boolean = false>(options: Options<PostapiV1ActivityUuidThreadMessageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/activity/{uuid}/thread/message',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postapiV1ActivityUuidEvaluate = <ThrowOnError extends boolean = false>(options: Options<PostapiV1ActivityUuidEvaluateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/activity/{uuid}/evaluate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const getApiV1ContentSyllabusAfoid = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ContentSyllabusAfoidData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiV1ContentSyllabusAfoidResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/content/syllabus/{afoId}',
        ...options
    });
};

export const getApiV1ContentSyllabusAfoidExtended = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ContentSyllabusAfoidExtendedData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetApiV1ContentSyllabusAfoidExtendedResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/content/syllabus/{afoId}/extended',
        ...options
    });
};

export const getApiV1ContentIdIsProcessed = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ContentIdIsProcessedData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/content/{id}/is-processed',
        ...options
    });
};

export const postapiV1ActivityObjective = <ThrowOnError extends boolean = false>(options: Options<PostapiV1ActivityObjectiveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostapiV1ActivityObjectiveResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/activity/objective',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postapiV1ActivityDiscover = <ThrowOnError extends boolean = false>(options: Options<PostapiV1ActivityDiscoverData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostapiV1ActivityDiscoverResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/activity/discover',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postapiV1ActivityPodcast = <ThrowOnError extends boolean = false>(options: Options<PostapiV1ActivityPodcastData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostapiV1ActivityPodcastResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/activity/podcast',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postapiV1ActivityApplication = <ThrowOnError extends boolean = false>(options: Options<PostapiV1ActivityApplicationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostapiV1ActivityApplicationResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/activity/application',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postapiV1ActivityBibliography = <ThrowOnError extends boolean = false>(options: Options<PostapiV1ActivityBibliographyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostapiV1ActivityBibliographyResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/activity/bibliography',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postapiV1ActivityExplainSimple = <ThrowOnError extends boolean = false>(options: Options<PostapiV1ActivityExplainSimpleData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostapiV1ActivityExplainSimpleResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/activity/explain-simple',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postapiV1ActivityRemember = <ThrowOnError extends boolean = false>(options: Options<PostapiV1ActivityRememberData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostapiV1ActivityRememberResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/activity/remember',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postapiV1ActivityRegulation = <ThrowOnError extends boolean = false>(options: Options<PostapiV1ActivityRegulationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostapiV1ActivityRegulationResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/activity/regulation',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const postapiV1ActivityGlossary = <ThrowOnError extends boolean = false>(options: Options<PostapiV1ActivityGlossaryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostapiV1ActivityGlossaryResponse, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/activity/glossary',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

export const getApiV1ContentUserUseridCourseUdiidContent = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ContentUserUseridCourseUdiidContentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        security: [
            {
                name: 'x-api-key',
                type: 'apiKey'
            }
        ],
        url: '/api/v1/content/user/{userId}/course/{udiId}/content',
        ...options
    });
};